import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { ModalClose } from '../components/modal-close.tsx';


export default function ModalInfoKostensteigerung() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1 id="modal-title">Kostensteigerung</h1>
            <p id="modal-description">Die Energiepreissteigerung ist in der Ausgangsberechnung in Anlehnung an die Inflationsrate mit 3,0 % angegeben. Möchten Sie simulieren wie sich die Maßnahmen bei einer höheren Preissteigerung rechnen, können Sie den Prozentsatz nach oben anpassen. Bei Annahme einer geringen Preissteigerung kann der Prozentsatz nach unten angepasst werden.</p>
             <ModalClose label={"weiter"} onClick={()=>{
                pop_modal();
            }}/>
         </Panel>)
}

